export const CHAT_OPEN_MODAL = "CHAT_OPEN_MODAL";
export const CHAT_CLOSE_MODAL = "CHAT_CLOSE_MODAL";
export const UPDATE_CHAT_HISTORY = "UPDATE_CHAT_HISTORY";
export const CLEAR_CHAT_HISTORY = "CLEAR_CHAT_HISTORY";
export const CLOSE_MULTI_CHAT_MODAL = "CLOSE_MULTI_CHAT_MODAL";
export const OPEN_MULTI_CHAT_MODAL = "OPEN_MULTI_CHAT_MODAL";
export const SET_PANEL_CHAT_HISTORY = "SET_PANEL_CHAT_HISTORY";
export const SET_SIDEBAR_CHAT_HISTORY = "SET_SIDEBAR_CHAT_HISTORY";
export const SET_CURRENT_SESSION_ID = "SET_CURRENT_SESSION_ID";
export const SET_SESSIONS_LOADING = "SET_SESSIONS_LOADING";
export const SET_ACTIVE_SOURCES = "SET_ACTIVE_SOURCES";
export const UPDATE_CHAT_OPTIONS = "UPDATE_CHAT_OPTIONS";
export const SET_ACTIVE_CHAT_CONFIG = "SET_ACTIVE_CHAT_CONFIG";
export const CHAT_SET_SHOW_ALL_SOURCES = "CHAT_SET_SHOW_ALL_SOURCES";
export const APPEND_CHAT_HISTORY = "APPEND_CHAT_HISTORY";
export const SET_CHAT_HAS_NEXT_PAGE = "SET_CHAT_HAS_NEXT_PAGE";
export const SET_FORCE_SINGLE_DOC_CHAT_DISPLAY = "SET_FORCE_SINGLE_DOC_CHAT_DISPLAY";
export const CLEAR_FORCE_SINGLE_DOC_CHAT_DISPLAY = "CLEAR_FORCE_SINGLE_DOC_CHAT_DISPLAY";
